<template>
  <money
    v-model="model"
    v-bind="{ ...moneyConfig, ...$attrs }"
    v-on="$listeners"
    class="form-control"
  />
</template>

<script>
export default {
  name: 'VMoeda',
  props: {
    value: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    moneyConfig() {
      return {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false // retorna como número (ex: 1234.56), true se quiser string formatada
      };
    }
  }
};
</script>
